import http from '@/services/api';

const RESOURCE_NAME = 'api/avatar';

export default {
  getAgentAvatar(contactId) {
    return http.get(`${RESOURCE_NAME}/${contactId}`);
  },

  getContactAvatar(customerId) {
    return http.get(`${RESOURCE_NAME}/contact/${customerId}`);
  },

  requestAvatarBatch(agentIds) {
    return http.post(`${RESOURCE_NAME}/batch`, { userIds: agentIds });
  },

  requestCustomerAvatarBatch(contactIds) {
    return http.post(`${RESOURCE_NAME}/contact/batch`, { userIds: contactIds });
  },

  createAgentAvatar(contactId, avatar) {
    return http.post(`${RESOURCE_NAME}/encoded/${contactId}`, { avatar });
  },

  updateAgentAvatar(contactId, avatar) {
    return http.put(`${RESOURCE_NAME}/encoded/${contactId}`, { avatar });
  },

  createContactAvatar(customerId, avatar) {
    return http.post(`${RESOURCE_NAME}/contact/encoded/${customerId}`, { avatar });
  },

  updateContactAvatar(customerId, avatar) {
    return http.put(`${RESOURCE_NAME}/contact/encoded/${customerId}`, { avatar });
  }
};
